import React, { Fragment } from 'react'
import estilos from '../../Tabs/TabsInspeccionarComponent.module.css'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { withRouter } from 'react-router-dom'
import Collapsible from 'react-collapsible';


function SeccionFotogaleriaComponent(props) {

  const valores = props.valores
  const nombreSeccion = props.nombreSeccion
  const metodo = props.metodo

  return (
    <Collapsible trigger={nombreSeccion} open={true}>
      <div className={`${estilos.gridFotos} mb-2`}>
        {valores?.map((foto, index) => {
          try {
            if (foto != undefined) {
              let url = URL.createObjectURL(foto)
              return (
                <div key={index} className=''>
                  <picture key={index}>
                    <img srcSet={url} width="500" className="img-fluid img-thumbnail" alt="..." />
                  </picture>
                </div>
              )
            }
            else {
              console.log("is undefined")
            }
          } catch (error) {
            console.log(error)
          }

        })}

      </div>
      <div className='row mb-3'>
        <div className="col-md-12 mb-3">
          <Field type="file" className="form-control form-control-sm" id="anexarfoto" name="anexarfoto" placeholder="" accept="image/png,image/jpeg" multiple={false} onChange={metodo}></Field>
        </div>
      </div>
    </Collapsible>
  );
};


export default withRouter(SeccionFotogaleriaComponent)
